import React from "react";

const QUEUE_OPTIONS = [
  { value: "", label: "Toutes les queues" },
  { value: "generer-quittance-prime", label: "Générer quittance prime" },
];

const TYPE_OPTIONS = [
  { value: "", label: "Tous les types" },
  { value: "GENERATION_DOCUMENT", label: "Erreur de génération de document" },
  { value: "AUTRE", label: "Autre" },
];

const FailedJobsFilters = ({ filters, onFilterChange, onSearch, onReset }) => {
  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      onSearch();
    }
  };

  return (
    <div className="card shadow-sm">
      <div className="card-body">
        <div className="row align-items-end">
          <div className="col-12 col-md-4 mb-2">
            <label className="font-weight-bold small">Recherche</label>
            <input
              type="text"
              className="form-control"
              name="terms"
              value={filters.filters.terms}
              onChange={onFilterChange}
              onKeyDown={handleKeyDown}
              placeholder="Rechercher dans les jobs..."
            />
          </div>
          <div className="col-12 col-md-3 mb-2">
            <label className="font-weight-bold small">Queue</label>
            <select
              className="form-control"
              name="queue"
              value={filters.filters.queue}
              onChange={onFilterChange}
            >
              {QUEUE_OPTIONS.map((opt) => (
                <option key={opt.value} value={opt.value}>
                  {opt.label}
                </option>
              ))}
            </select>
          </div>
          <div className="col-12 col-md-3 mb-2">
            <label className="font-weight-bold small">Type d'erreur</label>
            <select
              className="form-control"
              name="type"
              value={filters.filters.type}
              onChange={onFilterChange}
            >
              {TYPE_OPTIONS.map((opt) => (
                <option key={opt.value} value={opt.value}>
                  {opt.label}
                </option>
              ))}
            </select>
          </div>
          <div className="col-12 col-md-2 mb-2 d-flex" style={{ gap: 8 }}>
            <button
              className="btn btn-primary flex-fill"
              onClick={onSearch}
            >
              <i className="fa fa-search mr-1" />
              Rechercher
            </button>
            <button
              className="btn btn-outline-secondary"
              onClick={onReset}
              title="Réinitialiser les filtres"
            >
              <i className="fa fa-times" />
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FailedJobsFilters;
